import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { LoadingController, NavParams, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { ConfigService } from 'src/app/services/config/config.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { EventsService } from 'src/app/services/event/event.service';

declare function returnPNM(): any;
declare var window: any;

@Component({
  selector: 'app-deposit-paynearme-v2',
  templateUrl: './deposit-paynearme-v2.component.html',
  styleUrls: ['./deposit-paynearme-v2.component.scss'],
})
export class DepositPaynearmeV2Component extends CashierBase implements OnInit {
  myScriptElement: HTMLScriptElement;
  @Input() public navigateBackPage: any;

  public bonusCode: string;
  public buttonDisabled: boolean = false;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public paymentType: any = [];
  public minAmount: any;
  public amount: AbstractControl;
  public PNM: any; //be careful not use before it's been inited on submission!
  public modalElement: any;
  public containerOpen: boolean = false;
  public loading: any;
  public processing: any;
  public currentTransactionID: string;
  private subscriptionDepositSuccess;
  private subscriptionDepositFailure;
  public timeout;
  public depositFormObj: any;
  private isIAB: boolean = false;
  private isIABOpened: boolean = false;
  private paynearmeApiLink: any;
  showPending: boolean = false;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
    public config: ConfigService,
    public loadingController: LoadingController,
    public depositService: DepositService,
    public accountBalanceService: AccountBalanceService,
    private navParams: NavParams,
    private eventsService: EventsService,
    private platform: Platform
  ) {
    super();
    this.labels = new DepositMainModel();
    this.successMessageService.clearMessage();
    this.handlePnmCallback = this.handlePnmCallback.bind(this); // binding callback, to avoid loose of context
    this.initScript();
  }

  ngOnInit(): void {
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
    this.depositFormObj = this.navParams.get('depositFormObj');
    this.initPnm();
  }

  ionViewDidEnter() {
    this.subscriptionDepositSuccess = this.eventsService.subscribe('event:deposit', (data) => {
      this.transactionClosure(true, data);
    });

    this.subscriptionDepositFailure = this.eventsService.subscribe('event:deposit:failed', (data) => {
      this.transactionClosure(false, data);
    });

    //add fail deposit event
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('paynearme').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  initScript() {
    this.myScriptElement = document.createElement("script");
    this.paynearmeApiLink = this.config.getConfig().FEATURE_PAYNEARME_V2_API_LINK;
    this.myScriptElement.src = this.paynearmeApiLink;
    document.body.appendChild(this.myScriptElement);
  }

  private callOutToIAB(token, paymentRequestID) {
    var url = this.config.getConfig().LOBBY_URL+'/assets/static/pay_near_me_v2/pay_near_me_v2.html';
    // var url = 'http://10.25.32.23:8100/assets/static/pay_near_me_v2/pay_near_me_v2.html';
    this.isIAB = true;
    this.isIABOpened = true;
    var params = {
      t: Date.now(),
    };

    var queryString = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');

    return new Promise( (resolve, reject) => {
      var windowRef = window.cordova.InAppBrowser.open( url+'?'+queryString, '_blank', 'location=no');
    
      windowRef.addEventListener( 'loaderror', event => {
        console.log( 'MEEP: loaderror');
      });

      windowRef.addEventListener( 'loadstart', event => {
        console.log( 'MEEP: loadstart');
      });

      windowRef.addEventListener( 'exit', event => {
        console.log( 'MEEP: exit');
        if(this.isIABOpened) {
          this.handleIabCallback({status: "exit"});
        }
      });

      windowRef.addEventListener( 'loadstop', (evt:any) => {
        console.log( 'MEEP: loadstop');
	      windowRef.executeScript( { code: `
          loadPaynearmeScript("${this.paynearmeApiLink}", function() {
                initializePaynearme('${token}', ${this.depositFormObj.amount}, '${this.depositFormObj.depositMethod}', '${paymentRequestID}');
            });`
          });
        var id = setInterval( () => {
          windowRef.executeScript( {code: "window.__paynearme_payload"}, result => {
            if( result[0]) {
              this.isIABOpened = false;
              clearInterval( id);
              var result = JSON.parse( result[0]);
              this.handleIabCallback(result);        
              windowRef.close();
            }
          });
        }, 50);
      });
      this.loading.dismiss();
    });
  }

  private handleIabCallback(data) {
    if(this.isIAB){
      if(!data.status) {
        console.error('[handlePnmCallback] Missing expected field');
        return this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: "Unknown error occured!" });
      } else if (data.status == "exit" ) {
        return this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: "Transaction Cancelled" });
      } else if (data.status == "complete") {
        this.showProcessing();
      }
    }
  }

  initPnm() {
    this.showLoading();
    this.containerOpen = true;

    // We only support cash for now, therefore amount is set by user in physical store
    // For later integration, broad integration, we should implement passing value into the component 
    const depositObj: any = {};
    depositObj.amount = 25;
    depositObj.bonusCode = this.bonusCode;
    depositObj.payment_type_code = "USD";
    depositObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;

    // Cash have different API to use, with out triggering deposit
    // if (this.depositFormObj.depositMethod == "CASH") {
      this.cashierService.callPayNearMeV2Cash(depositObj).subscribe((response) => {
        console.log("response", response);
        if (response.result == 1) {
          this.PNM = returnPNM();
          this.PNM.init({
            "auto_resize": true,
            "language": "en",
            "header_size": "18",
            "header_bkgnd": "DF9",
            "header_color": "000",

            "callback": this.handlePnmCallback,
            "target": "demo_container",

            "actions": {
              "deposit": {
                "action": "pay",
                "header": "Deposit",
                "payment_amount": depositObj.amount,
                "payment_field_fixed": true,
                "cash": true
              }
            },
            "header": "",
            "display_receipt": "false",
            "hide_saved_payment_methods": "",
            "require_push_enabled": "",
            "order_token": response.payload
          });

          this.pnmCallbackSetUp()

        } else {
          this.loading.dismiss();
        }
      }, (error) => {
        //possible errors and rejections handling
        switch (error.getErrorCode().toUpperCase()) {
          case 'OVER_DEPOSIT_LIMIT':
            this.loading.dismiss();
            this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: `You have exceeded your maximum deposit limit.` });
            break;
        }

      });

    // } else {

    //   this.cashierService.callPayNearMeV2(depositObj).subscribe((response) => {

    //     if (response.result == 1) {
    //     const iabPaymentTypes = this.config.getConfig().PAYNEARME_IAB_PAYMENT_TYPES || ['VVAP'];
    //     if(this.platform.is('capacitor') && iabPaymentTypes.includes(this.depositFormObj.depositMethod)) {
    //       // this.callOutToIAB(response.payload.parameters.secureSmartToken, response.payload.paymentRequestID);
    //     } else {
    //       this.PNM = returnPNM();
    //       this.PNM.init({

    //         "data": {
    //           "ext_payid": response.payload.paymentRequestID,

    //           // "min_disbursement_amount": "20.00",
    //           // "max_disbursement_amount": "500.00",
    //           // "disbursement_balance_amount": "4000.00"
    //         },
    //         "auto_resize": true,
    //         "language": "en",
    //         "header_size": "18",
    //         "header_bkgnd": "DF9",
    //         "header_color": "000",

    //         "callback": this.handlePnmCallback,
    //         "target": "demo_container",

    //         "actions": {
    //           "deposit": {
    //             "action": "pay",
    //             "header": "Deposit",
    //             "payment_amount": this.depositFormObj.amount,
    //             "payment_field_fixed": true,
    //             "debit": this.depositFormObj.depositMethod === "CREDIT",
    //             "credit": this.depositFormObj.depositMethod === "CREDIT",
    //             "ach": this.depositFormObj.depositMethod === "ACH",
    //             "apple_pay": this.depositFormObj.depositMethod === "VVAP",
    //             "cash_app": this.depositFormObj.depositMethod == 'CAPP',
    //             "google_pay": false,
    //             "paypal": this.depositFormObj.depositMethod === "PPD",
    //             "venmo": this.depositFormObj.depositMethod === "VEN",
    //             "pin4": false,
    //             "cash": this.depositFormObj.depositMethod === "PNMV2",
    //             "trustly": this.depositFormObj.depositMethod === "PWB",
    //           }
    //         },
    //         "header": "",
    //         "display_receipt": "false",
    //         "hide_saved_payment_methods": "",
    //         "require_push_enabled": "",
    //         "order_token": response.payload.parameters.secureSmartToken
    //       });

    //       this.pnmCallbackSetUp();
    //     }
    //     } else {
    //       this.loading.dismiss();
    //     }
    //   }, (error) => {
    //     //possible errors and rejections handling
    //     switch (error.getErrorCode().toUpperCase()) {
    //       case 'OVER_DEPOSIT_LIMIT':
    //         this.loading.dismiss();
    //         this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: `You have exceeded your maximum deposit limit.` });
    //         break;
    //     }

    //   });
    // }

    this.successMessageService.clearMessage();
    this.error = null;

  }

  pnmCallbackSetUp() {
    //overwriting console callbacks, so we can track state of iframe window
    let listenerSetUp = this.PNM.console;
    this.PNM.console = (input) => {
      listenerSetUp(input);

      if (input[0] == "receiveMessage") {
        this.loading.dismiss();

        // if any code have to be responding to inner callbacks of deposit, pu it here
      }
    };
    //Launching iframe
    this.PNM.launch('deposit');
    let container = document.getElementsByClassName("_pnm_ifr")[0];
    container.setAttribute("style", "min-height: 80vh; width:100%; height:100%; border:0; box-shadow: none; overflow: hidden;");
    container.setAttribute("scrolling", "no");;
  }

  public handlePnmCallback(data) {

    if (this.PNM) {
      if (!data.status) {
        // status should always be present
        // for any messages posted by the PNM iFrame.
        console.error('[handlePnmCallback] Missing expected field');
        this.loading?.dismiss();
        this.showPending = false;
        this.processing?.dismiss();
        return this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: "Unknown error occured!" });
      }
      var msg = "";
      
      if (data.status == "complete" ||
        data.status == "exit") {
          this.showProcessing();
        msg = "Status: " + data.status + "\n";
        if (data.message) {
          msg += data.message.join("\n");
        }
      }

      console.log("test message : ", msg);

    }
 //   this.loading?.dismiss();
  }

  public PNMCloseInner() {
    this.containerOpen = false;
    this.PNM.close();
    this.PNM = undefined;
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  onBack = () => {
    this.PNMCloseInner();
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 10000
    });

    this.loading.present();
  }

  async showProcessing() {
    this.containerOpen = false;
    this.showPending = true;
    // this.processing = await this.loadingController.create({
    //   message: 'Processing...',
    //   duration: 10000
    // });

    // this.processing.present();
  }


  ngOnDestroy() {
    this.subscriptionDepositFailure.unsubscribe();
    this.subscriptionDepositSuccess.unsubscribe();
  }

  ////
  // Not used anymore, as switched to rely on notifications
  // Leave it here for now, to use as refference for all scenarios possible wih deposit
  ////

  // public checkDeposit(paymentRequestId: any) {
  //   if (!isUndefined(paymentRequestId)) {
  //     this.depositService
  //       .checkDepositStatus(paymentRequestId)
  //       .pipe(first())
  //       .subscribe(
  //         (response) => {
  //           clearTimeout(this.timeout);
  //           this.loadingFinal.dismiss();
  //           if (!isUndefined(response.payload)) {

  //             setTimeout(() => this.accountBalanceService.updateBalance(), 200);

  //             switch (response.payload.status) {
  //               case "APPROVED":
  //                 let depositLimitExceeded = false;

  //                 if ("hasExceededDepositLimit" in response.payload) {
  //                   depositLimitExceeded =
  //                     response.payload.hasExceededDepositLimit;
  //                 }
  //                 this.navigator.dismissAll();
  //                 if (depositLimitExceeded) {
  //                   this.navigator.navigateTo(
  //                     "DepositThresholdComponent",
  //                     {},
  //                     {
  //                       status: true,
  //                       amount:this.depositFormObj.amount,
  //                       customerId: this.cashierService.customer.customerId,
  //                     }
  //                   );
  //                   break;
  //                 }

  //                 this.navigator.navigateTo(
  //                   "DepositSuccessFailureComponent",
  //                   {},
  //                   { status: true, message: "$" + this.depositFormObj.amount + " was deposited to your account." }
  //                 );
  //                 break;
  //               case "IN PROCESS":
  //                 this.navigator.navigateTo(
  //                   "DepositSuccessFailureComponent",
  //                   {},
  //                   {
  //                     status: false,
  //                     navigateBackPage: "DepositPaynearmeV2Component",
  //                     flagPending: true,
  //                     message:
  //                       "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
  //                   }
  //                 );
  //                 break;
  //               case "CANCELLED":
  //                 this.navigator.navigateTo(
  //                   "DepositSuccessFailureComponent",
  //                   {},
  //                   {
  //                     status: false,
  //                     navigateBackPage: "DepositPaynearmeV2Component",
  //                     message: "Your deposit transaction did not succeed.",
  //                   }
  //                 );
  //                 break;
  //               default:
  //                 this.navigator.navigateTo(
  //                   "DepositSuccessFailureComponent",
  //                   {},
  //                   {
  //                     status: false,
  //                     navigateBackPage: "DepositPaynearmeV2Component",
  //                     message:
  //                       "Your deposit transaction could not be processed.",
  //                   }
  //                 );
  //                 break;
  //             }
  //             return;
  //           }
  //           return this.navigator.navigateTo(
  //             "DepositSuccessFailureComponent",
  //             {},
  //             {
  //               status: false,
  //               navigateBackPage: "DepositPaynearmeV2Component",
  //             }
  //           );
  //         },
  //         (error) => {
  //           return this.navigator.navigateTo(
  //             "DepositSuccessFailureComponent",
  //             {},
  //             {
  //               status: false,
  //               navigateBackPage: "DepositPaynearmeV2Component",
  //             }
  //           );
  //         }
  //       );
  //   }
  // }

  transactionClosure(approved: boolean, data: any) {
    if(this.processing)this.processing.dismiss();
    this.showPending = false;
    if(this.loading)this.loading.dismiss();
    if(!this.platform.is("capacitor")){
      this.PNMCloseInner();
    }
    if (approved) {
      this.navigator.navigateTo(
        "DepositSuccessFailureComponent",
        {},
        { status: true, message: "$" + data.amount + " was deposited to your account." }
      );
    } else {
      this.navigator.navigateTo(
        "DepositSuccessFailureComponent",
        {},
        {
          status: false,
          navigateBackPage: "DepositPaynearmeV2Component",
          message:
            "Your deposit transaction could not be processed.",
        }
      );
    }
    // this.checkDeposit(this.currentTransactionID);
  }


}
